<!--
// app/pages/[region]/Faqs.vue
-->
<script setup lang="ts">
import HeaderBannerTitle from "~/app/components/Shared/HeaderBannerTitle.vue";
import FaqItem from "~/app/components/pages/region-faqs/FaqItem.vue";
import faqsUiService from "~/src/content/infrastructure/ui-services/faqsUiService";

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: "/[region]/faqs",
    es: "/[region]/faqs",
    de: "/[region]/faqs",
    fr: "/[region]/faqs",
    it: "/[region]/faqs",
    pt: "/[region]/faqs",
  },
});

definePageMeta({
  middleware: [
    "not-found-americas",
    "not-found-world-cup",
    "not-found-italy",
    "not-found-queens",
    "not-found-nations",
    "not-found-king-of-kings-nations",
    "not-found-brazil",
    "not-found-france",
    "not-found-germany",
  ],
});

const { getFaqs } = faqsUiService();
const { t } = useI18n();

const faqs = await getFaqs();

useSeoMeta({
  title: t("footer.nav.faqs"),
  ogTitle: t("footer.nav.faqs"),
});
</script>

<template>
  <header-banner-title :title="$t('footer.nav.faqs')"></header-banner-title>
  <section v-if="faqs" class="bg-gray-900 py-12 md:py-24 min-h-full">
    <div class="max-w-2xl mx-auto">
      <div id="faqs-accordion">
        <faq-item v-for="faq in faqs" :key="faq.id" :title="faq.title" :content="faq.content.rendered">
        </faq-item>
      </div>
    </div>
  </section>
</template>

<style scoped></style>
